/* global analytics */
import { useEffect, useRef } from 'react'

import useReduxSelector from 'hooks/useReduxSelector'
import useDispatch from 'hooks/useDispatch'

import { fetchDetectedMarketHome } from '../../actions/homeActions'

// The global home is edge-cached without any viewer market, so resolve the
// visitor's market after hydration and swap the seed in place. Market and
// country homes already name their market/country in the URL — leave them be.
const useDetectedMarketHome = () => {
  const dispatch = useDispatch()
  const data = useReduxSelector((state) => state?.home?.data)
  const isGlobalSeed = data != null && !data.currentMarket && !data.country

  // Captured at mount: a market appearing later means the seed was swapped,
  // not a direct market page visit.
  const mountedGlobal = useRef(isGlobalSeed)
  const detectedCode = mountedGlobal.current ? data?.currentMarket?.code : null

  useEffect(() => {
    if (isGlobalSeed) {
      dispatch(fetchDetectedMarketHome())
    }
  }, [isGlobalSeed, dispatch])

  // The pageview fires before detection resolves, so the swap gets its own
  // event to measure geo-adaptation against the neutral home.
  useEffect(() => {
    if (detectedCode) {
      analytics.track('Homepage Market Detected', { market: detectedCode })
    }
  }, [detectedCode])
}

export default useDetectedMarketHome
